import { render } from "./AppointmentDetails.vue?vue&type=template&id=24f7082e&scoped=true"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"

import "./AppointmentDetails.vue?vue&type=style&index=0&id=24f7082e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f7082e"]])

export default __exports__